import React from 'react';
import { Card, CardBody, CardHeader, Container, Row } from 'reactstrap';
import { Breadcrumbs, H5 } from '../../../AbstractElements';
import { WishlistTitle } from '../../../Constant';
import WishListData from './WishListData';

const WishListContainer = () => {
  return (
    <>
      <Container fluid={true} className='product-wrapper'>
        <Breadcrumbs justify='end' pageTitle='Wishlist' parent='Ecommerce' title='Wishlist' />
        <Row>
          <Card>
            <CardHeader className='pb-0'>
              <H5>{WishlistTitle}</H5>
            </CardHeader>
            <CardBody className='whishlist-main'>
              <WishListData />
            </CardBody>
          </Card>
        </Row>
      </Container>
    </>
  );
};

export default WishListContainer;
